import React from "react";
import './css/CourseHeaderStyle.css';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function HeaderTop() {
    const location = useLocation(); // ✅ React Router hook se location milega

    const titles = {
        "/AssistantprofessorHPSC": "HPSC Assistant Professor",
        "/AssistantprofessorJKPSC": "JKPSC Assistant Professor",
        "/AssistantprofessorMPPSC": "MPPSC Assistant Professor",
        "/AssistantprofessorPPSC": "PPSC Assistant Professor",
        "/AssistantprofessorRPSC": "RPSC Assistant Professor",
        "/AssistantprofessorCGPSC": "CGPSC Assistant Professor",
        "/AssistantprofessorUKPSC": "UKPSC Assistant Professor",
        "/AssistantprofessorUPPSC": "UPPSC Assistant Professor",
        "/PGTNVSKVS": "PGT NVS KVS",
        "/PGTDSSSB": "PGT DSSSB",
        "/PGTHPSC": "PGT HPSC",
        "/PGTMPPSC": "PGT MPPSC",
        "/PGTRPSC": "PGT RPSC",
        "/PGTUPPSC": "PGT UPPSC",
        "/PGTPPSC": "PGT PPSC",
    };
    const title = titles[location.pathname] || "My Website";

    const buttonTextMap = {
        "/AssistantprofessorHPSC": "Books",
        "/AssistantprofessorJKPSC": "Books",
        "/AssistantprofessorMPPSC": "Books",
        "/AssistantprofessorPPSC": "Books",
        "/AssistantprofessorRPSC": "Books",
        "/AssistantprofessorCGPSC": "Books",
        "/AssistantprofessorUKPSC": "Books",
        "/AssistantprofessorUPPSC": "Books",
        "/PGTNVSKVS": "Books",
        "/PGTDSSSB": "Books",
        "/PGTHPSC": "Books",
        "/PGTMPPSC": "Books",
        "/PGTRPSC": "Books",
        "/PGTUPPSC": "Books",
        "/PGTPPSC": "Books",
    }
    const buttonText = buttonTextMap[location.pathname] || "Pass";

    return (
            <div className="headerTop">
                    <div class="container py-5">
                        <div class="d-flex align-items-center mb-3">
                            <h2 class="fw-bold mb-0">{title}  Previous Year Question Paper PDFs With Solutions </h2>
                        </div>
    
                        {/* <span class="badge badge-custom mb-3">73+ PYP Tests</span> */}
    
                        <p class="mb-3"><i class="bi bi-check2 text-white"></i> Also Unlock 35000+ PYP's with VIGYAN VRIKSH MEMBER On Youtube</p>
                        {/* <p class="mb-3">
                            <i class="bi bi-check-circle-fill text-whiet"></i> Also <b>Unlock 35000+ PYP’s</b> with <span class="fw-bold text-white">testbook <span class="badge bg-warning text-dark">PRO</span></span>
                        </p> */}
    
                        <div class="mb-4">
                            <Link class="btn btn-outline-custom btn-lg me-3">Test Series</Link> 
                            <Link class="btn btn-outline-custom btn-lg">Complete Course</Link><br/><br/>
                            <Link class="btn btn-green btn-lg me-3">Get {buttonText} Pro Now</Link>
                            <Link class="btn btn-outline-custom btn-lg">Question Bank</Link>
                        </div>
    
                        <p class="text-white"><i class="bi bi-people-fill me-1"></i> <b>37.2k</b> Students Improve their score through VIGYAN VRIKSH</p>
    
                    </div>
                </div>
    );
}

export default HeaderTop;